export const bonuses = [
  {
    n: 1,
    image: 'https://cdn.magicpatterns.com/uploads/pe2U5zL7WfeFAQoEQzkagF/BONSU_1_CLEAR-EN.png',
    title: 'Clear Aligner Case Analysis Cards™',
    subtitle: 'Illustrative clinical scenarios to organize your case-review thinking.',
    text: 'This collection of case-analysis cards provides structured prompts for reviewing different clinical presentations and documenting relevant questions.',
    items: [
      'Clinical findings prompts.',
      'Case assessment questions.',
      'Treatment objective considerations.',
      'Biomechanical review prompts.',
      'Planning considerations.',
      'Space for notes and observations.',
    ],
    designedFor: 'Professionals who want a repeatable structure for discussing and reviewing clinical scenarios.',
    value: 37,
    note: '',
  },
  {
    n: 2,
    image: 'https://cdn.magicpatterns.com/uploads/5xZyqfJ7VwCMfFEuriwsGY/BONUS_2_CLEAR-EN.png',
    title: 'The Clear Aligner Case Mapping Workbook™',
    subtitle: 'A step-by-step worksheet system for organizing case information.',
    text: 'Use the workbook format to bring relevant findings, objectives, biomechanical considerations, and treatment stages into a coordinated planning document.',
    items: [
      'Case assessment worksheets.',
      'Treatment objective maps.',
      'Biomechanical considerations pages.',
      'Treatment sequencing worksheets.',
      'Monitoring templates.',
      'Case review summaries.',
    ],
    designedFor: 'Professionals who prefer a visual, organized way to document their case-planning considerations.',
    value: 27,
    note: '',
  },
  {
    n: 3,
    image: 'https://cdn.magicpatterns.com/uploads/hAwi2PMdD1VsipC6sy9u3M/BONUS_3_CLEAR-EN.png',
    title: 'The Clear Aligner Biomechanics Review Checklist™',
    subtitle: 'A structured checklist for reviewing movement-related questions.',
    text: 'Use this resource to organize the biomechanical factors that may need additional attention during digital treatment plan review.',
    items: [
      'Tooth movement review prompts.',
      'Attachment considerations.',
      'Anchorage questions.',
      'Movement predictability factors.',
      'Potential limitations to investigate.',
      'Clinical review checklist.',
    ],
    designedFor: 'Professionals who want a consistent set of questions to guide their educational and planning reviews.',
    value: 29,
    note: '',
  },
  {
    n: 4,
    image: 'https://cdn.magicpatterns.com/uploads/iEYyDVEEXeEf6ZW8kckskw/BONUS_4_CLEAR-EN.png',
    title: 'The Clear Aligner Troubleshooting Casebook™',
    subtitle: 'Structured scenarios for examining common treatment-planning challenges.',
    text: 'Explore educational case scenarios designed to prompt analysis of discrepancies, possible contributing factors, and questions for further evaluation.',
    items: [
      'Tracking discrepancy scenarios.',
      'Midline deviation discussion prompts.',
      'Rotation-related review questions.',
      'Incomplete movement scenarios.',
      'Posterior occlusal considerations.',
      'A structured case-analysis framework.',
    ],
    designedFor: 'Professionals who want to practice organizing their reasoning when a case does not progress as anticipated.',
    value: 27,
    note: 'The scenarios are educational exercises, not patient-specific treatment instructions.',
  },
  {
    n: 5,
    image: 'https://cdn.magicpatterns.com/uploads/w6n9mktN79sakUoBF5VVBf/BONUS_5_CLEAR-EN.png',
    title: 'The One-Page Clear Aligner Case Review Template™',
    subtitle: 'Bring the essential elements of a case review into one organized document.',
    text: 'Use this visual template to summarize the key areas of a clear aligner case review.',
    items: [
      'Diagnosis and clinical findings.',
      'Treatment objectives.',
      'Biomechanical considerations.',
      'Treatment sequence overview.',
      'Monitoring and reassessment.',
      'Final case summary.',
    ],
    designedFor: 'Professionals who want a concise format for documenting the main components of their case review.',
    value: 27,
    note: '',
  },
]
